import React, { useEffect, useState } from "react";
import { getJobPostings } from "service/formService";
import styles from "./JobOpenings.module.scss";
import Loader from "../Loader/Loader";
import { Link } from "react-router-dom";

const JobOpenings = (props) => {
  const [jobPostings, setJobPostings] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const response = await getJobPostings();
        setJobPostings(response.data);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        setJobPostings([]);
      }
    })();
  }, []);

  return (
    <>
      {loading && <div className={styles.loaderContainer}>
        <Loader />
      </div>}
      <div className={styles.container}>
        <div className={styles.subcontainer}>
          <h2 className={styles.heading}>Current Openings</h2>

          {loading === false &&
            jobPostings.map((posting, index) => {
              return (
                <div className={styles.job_item} key={index}>
                  <Link
                    to={{
                      pathname : "/current-openings/details",
                      search : `?id=${posting.jobPostingId}&position=${posting.position}`,
                      //state : posting
                    }}
                    className={styles.openings_row}
                  >
                    <span>{posting.position}</span>
                    <span className={styles.text_muted}>
                      {posting.locations}
                    </span>
                  </Link>
                </div>
              );
            })}

          {loading === false && jobPostings.length === 0 && (
            <p className={styles.openingsError}>There are no current openings.</p>
          )}

          <p className={styles.apply_tag}>If you don't find a job matching your profile, you can still apply <Link className={styles.apply_link} to={{pathname : "/apply"}}>here.</Link></p>
        </div>
      </div>
    </>
  );
};

export default JobOpenings;
